import { render, staticRenderFns } from "./ActiveAlerts.vue?vue&type=template&id=3561f072"
import script from "./ActiveAlerts.vue?vue&type=script&lang=js"
export * from "./ActiveAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports